<script setup lang="ts">
const props = defineProps<{
  modelValue?: string
  value: string
  label?: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'update:model-value', value: string): void
}>()

function onChange() {
  emit('update:modelValue', props.value)
  emit('update:model-value', props.value)
}
</script>

<template>
  <label class="auth-radio">
    <input
      type="radio"
      :checked="modelValue === value"
      @change="onChange"
    />
    <span class="auth-radio__label">{{ label }}</span>
  </label>
</template>
